 <ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
 <ng-container *ngIf="!loading">
<mapfre-card [singleCard]="false" [additionalClasses]="'billing-new-container'">
    <router-outlet></router-outlet>
</mapfre-card>
</ng-container>

